// extracted by mini-css-extract-plugin
export default {"box":"ratingStars_box__iI9Qi","star":"ratingStars_star__qnW6S"};